 const sliderData = [
  {
    id: 1,
    titre: "Arroz pilao",
    description: "arroz branco temperado com legumes, especiarias",
    imagem:"/pratos/arroz-pilao.jpg"
    
  },
  {
    id: 2,
    titre: "tembo",
    description:"sambusas e arroz pilao , salada de folhas",
    imagem:"/pratos/tembo.jpg"
  },
  {
    id: 3,
    titre:"feijoada do chef",
    description: "Feijão preto com legumes e mix de cogumelos, temperados com azeite de dendê e especiarias, arroz branco cozido no suco de gengibre, acompanha farofa de banana da terra, couve manteiga refogada na pasta de amendoim (couve na mwamba).",
    imagem:"/pratos/feijoada-do-chef.jpg"
  },
  {
    id: 4,
    titre:"mafe veg",
    description: "mafe-veg",
    imagem:"/pratos/mafe-veg.jpg"
  },
  {
    id: 5,
    titre:"kuku",
    description: "Acarajé Africano servido na cama de quiabo acompanha arroz branco e batata doce Chips",
    imagem:"/pratos/kuku.jpg"
  },
  {
    id:6,
    titre: "Madesu na Mbika",
    description: "Mbika (tipo de almôndegas a feito a base de semente de abóbora acompanha arroz branco e Feijão branco temperado no dendê, tomate fresco e especiarias.",
    imagem:"/pratos/Mbika-feijao.jpg"
  },
  {
    id:7,
    titre: "Simba",
    description: "Pilao (típico arroz congolês refogado com legumes no suco de gengibre, couve na mwamba (couve manteiga refogada na pasta de amendoim),- kachori (bolinho de batatinha, shimeji e gegibre assado) com ,chatini – creme feito a base de batatinha inglesa, leite de coco.",
    imagem:"/pratos/simba.jpg"
  },
  {
    id:8,
    titre: "Couve na mwamba",
    description: "Couve manteiga refogada na pasta de amendoim",
    imagem:"/pratos/couve-na-mwamba.jpg"
  },
  {
    id:9,
    titre: "Farofa de banana da terra ",
    description: "",
    imagem:"/pratos/farofa-de-banana.jpg"
  },
  {
    id:10,
    titre: "Farofa de amendoim",
    description: "",
    imagem:"/pratos/farofa-de-amendoim.jpg"
  },
  {
    id:11,
    titre: "Brownie de banana da terra ",
    description: "Brownie de banana da terra e cacau acompanha creme de hibisco",
    imagem:"/pratos/brownie-de-banana.jpg"
  },
  {
    id:12,
    titre: "Bissap",
    description: "Bebida típica africana a base de hibisco e manga",
    imagem:"/pratos/bissap.jpg"
  },
  {
    id:13,
    titre: "Tomi",
    description: "Bebida típica africana a base de tamarindo e manga .",
    imagem:"/pratos/tomi.jpg"
  },
  {
    id:14,
    titre: "Tangawisi",
    description: "Bebida típica africana a base de gengibre,abacaxi e limão ",
    imagem:"/pratos/tangawisi.jpg"
  },
  {
    id:15,
    titre: "Ngombe",
    description: "Nhoque de banana da terra ao molho de shimejo e tomates frescos",
    imagem:"/pratos/ngombe.jpg"
  }

]
export default sliderData;

